'use client';

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';
import { useId, useMemo, useState } from 'react';
import { Controller, type SubmitHandler, useForm } from 'react-hook-form';
import { z } from 'zod';
import { Button } from '~/components/Button';
import { Checkbox } from '~/components/Checkbox';
import { TextField } from '~/components/Form/TextField';
import { Box } from '~/components/Layout/Box';
import { Stack } from '~/components/Layout/Stack';
import { Link } from '~/components/Link';
import { Notification } from '~/components/Notification';
import { trackEmailSubmitted } from '~/utils';
import type { NewsletterFormProps } from './NewsletterForm.types';
const NewsletterForm = t0 => {
  const $ = _c(27);
  const {
    onSubscribe,
    source
  } = t0;
  const t = useTranslations();
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const checkboxId = useId();
  const sourceId = useId();
  let t1;
  if ($[0] !== t) {
    t1 = z.object({
      subscriptionEmail: z.string().email(t("content.feedback.email_invalid_format")).min(5, t("content.feedback.email_invalid_length")),
      source: z.string(),
      acceptPolicy: z.boolean().refine(_temp, t("content.feedback.privacy_required"))
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const newsletterSchema = t1;
  let t2;
  if ($[2] !== newsletterSchema) {
    t2 = zodResolver(newsletterSchema);
    $[2] = newsletterSchema;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = source ? source : "";
  let t4;
  if ($[4] !== t3) {
    t4 = {
      subscriptionEmail: "",
      source: t3,
      acceptPolicy: false
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = {
      resolver: t2,
      mode: "onBlur",
      defaultValues: t4
    };
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const methods = useForm(t5);
  const {
    control,
    handleSubmit,
    register
  } = methods;
  let t6;
  if ($[9] !== onSubscribe || $[10] !== t) {
    t6 = async data => {
      ;
      try {
        await onSubscribe(data.subscriptionEmail, data.source);
        trackEmailSubmitted(data.subscriptionEmail, "newsletter");
        setSuccessMessage(t("content.feedback.subscribe_success"));
      } catch (t7) {
        setErrorMessage(t("content.feedback.subscribe_error"));
      }
    };
    $[9] = onSubscribe;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onSubmit = t6;
  let t7;
  if ($[12] !== handleSubmit || $[13] !== onSubmit) {
    t7 = handleSubmit(onSubmit);
    $[12] = handleSubmit;
    $[13] = onSubmit;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== checkboxId || $[16] !== control || $[17] !== errorMessage || $[18] !== register || $[19] !== source || $[20] !== sourceId || $[21] !== successMessage || $[22] !== t) {
    t8 = successMessage ? <Box spaceTop="--by-space-400"><Notification state="success" message={successMessage} /></Box> : <Box spaceTop="--by-space-400"><Stack space="--by-space-400"><p className="text-neutral-700">{t.rich("content.privacy_prompt", {
            link: _temp2
          })}</p><Controller control={control} name="subscriptionEmail" render={t9 => {
          const {
            field: t10,
            fieldState: t11
          } = t9;
          const {
            name,
            value: value_0,
            onChange,
            ref
          } = t10;
          const {
            invalid,
            error
          } = t11;
          return <TextField name={name} type="email" value={value_0} onChange={onChange} validationBehavior="aria" isInvalid={invalid} label={t("forms.email_label")} ref={ref} errorMessage={error?.message} isRequired={true} />;
        }} /><p className="block text-black">{t("forms.privacy_label")}<span className="text-primary-600"> *</span></p><Controller control={control} name="acceptPolicy" render={t12 => {
          const {
            field: t13,
            fieldState: t14
          } = t12;
          const {
            name: name_0,
            onChange: onChange_0,
            value: value_1,
            ref: ref_0
          } = t13;
          const {
            invalid: invalid_0,
            error: error_0
          } = t14;
          return <Checkbox checked={value_1} id={checkboxId} name={name_0} onChange={e => onChange_0(e.target.checked)} label={t("content.forms.privacy_accepted")} error={invalid_0} errorText={error_0?.message} ref={ref_0} required={true} />;
        }} /><input type="hidden" id={sourceId} {...register("source")} value={source} /><Button type="submit" size="small" data-ua-click="newsletter-signup">{t("forms.submit")}</Button>{errorMessage && <Notification state="error" message={errorMessage} />}</Stack></Box>;
    $[15] = checkboxId;
    $[16] = control;
    $[17] = errorMessage;
    $[18] = register;
    $[19] = source;
    $[20] = sourceId;
    $[21] = successMessage;
    $[22] = t;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <form noValidate={true} onSubmit={t7}>{t8}</form>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export { NewsletterForm };
function _temp(value) {
  return value === true;
}
function _temp2(chunks) {
  return <Link hasUnderline={true} href="/legal/privacy-policy" target="_blank">{chunks}</Link>;
}